
import WarehouseIcon from '@mui/icons-material/Warehouse';

export const relationFinancialInvoicesConfig = {
    all:  {
        title: 'all_invoices',
        icon: <WarehouseIcon/>,
        isSingleDataGrid: true,
    },
    invoiceProducts:  {
        title: 'invoice_products',
        icon: <WarehouseIcon/>,
        isSingleDataGrid: true,
    },
};
